export const SIDEBAR_COLLAPSED_KEY = 'jobseeqr-sidebar-collapsed';

export function readSidebarCollapsed() {
  try {
    const stored = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
    if (stored !== null) return stored === 'true';
  } catch (_) { /* Keep navigation usable when storage is unavailable. */ }
  return window.matchMedia?.('(max-width: 760px)').matches || false;
}

export function isSourcingOnly(productTypes = []) {
  return productTypes.includes('tse') && !productTypes.some(type => ['ats', 'bundle'].includes(type));
}

export function getSourcingView(search = '') {
  const params = new URLSearchParams(search);
  if (params.has('shortlist')) return 'shortlists';
  const view = params.get('view');
  return ['search', 'shortlists', 'unlocked'].includes(view) ? view : null;
}
